import React, { type FC } from 'react';
import PropertyDetails from './PropertyDetails';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { store } from '../../redux/store';
import { enableMapSet } from 'immer';
import { FilteringProvider } from '../../contexts/Filtering';
import { LoginPromptProvider } from '../common/LoginPromptContext';
enableMapSet();

export type PropertyDetailPageProps = {
  propertyId: string;
  mapKey: string;
  streetViewKey: string;
  isLoggedIn: boolean;
};

const queryClient = new QueryClient();

const PropertyDetailPage: FC<PropertyDetailPageProps> = ({
  propertyId,
  mapKey,
  streetViewKey,
  isLoggedIn,
}) => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <FilteringProvider>
          <LoginPromptProvider isLoggedIn={isLoggedIn}>
            <div className="w-full">
              <PropertyDetails
                mapKey={mapKey}
                streetViewKey={streetViewKey}
                propertyId={propertyId}
              />
            </div>
          </LoginPromptProvider>
        </FilteringProvider>
      </QueryClientProvider>
    </Provider>
  );
};

export default PropertyDetailPage;
